import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'commercialPackage/';

class CommercialPackageService {

    async getCommercialPackages() {
        try {
            const response = await axios.get(API_URL + 'getAllCommercialPackages', { headers: authHeader() });
            return response.data;
        } catch (error) {
            console.error("Erreur lors de la récupération des commercial packages :", error);
            throw error; // pour que le composant sache qu'il y a eu une erreur
        }
    }

}

export default new CommercialPackageService();